module.exports = __webpack_public_path__ + "img/3b.03f495b4.jpg";